import { isPromise } from '@ibinder/common-utils';
import { useFeatureToggle } from '@ibinder/ui-common-hooks';

export const BINDER_COLOR = 'brown';
export const BINDER_NAME = 'Superadmin';

export const getTabs = (showBatchOperations) => {
  const { isEnabled: improveGlobalWorkflowTemplateList } = useFeatureToggle(
    // @ts-ignore -- TODO add to feat const /Jonathan 2026-01-12
    'Configcat_ImproveGlobalWorkflowTemplateList'
  );
  const tabs = [
    {
      id: '0',
      name: 'Organizations',
      subTabs: [],
      type: 'Organizations'
    },
    {
      id: '3',
      name: 'Manage Users',
      subTabs: [],
      type: 'Users'
    },
    {
      id: '4',
      name: improveGlobalWorkflowTemplateList ? 'Templates' : 'Inspections',
      subTabs: [
        {
          id: '14',
          name: 'Inspection Type Templates',
          subTabs: [],
          type: 'InspectionTypeTemplateForm'
        },
        {
          id: '22',
          name: 'Inspection Type Templates EU',
          subTabs: [],
          type: 'InspectionTypeTemplateFormEU'
        },
        ...(improveGlobalWorkflowTemplateList
        ? [
          {
            id: '23',
            name: 'Workflow Templates',
            subTabs: [],
            type: 'InspectionGlobalTemplates'
          }
        ]
        : [])
      ],
      type: 'Inspection'
    },
    {
      id: '8',
      name: 'Binders',
      subTabs: [],
      type: 'Binders'
    },
    {
      id: '18',
      name: 'Deleted Binders',
      subTabs: [],
      type: 'DeletedBinders'
    },
    {
      id: '15',
      name: 'Tenders',
      subTabs: [],
      type: 'Tenders'
    }
  ];

  if (
    !isPromise(showBatchOperations) &&
    showBatchOperations &&
    tabs.find((t) => t.id === '17') === undefined
  ) {
    tabs.push({
      id: '17',
      name: 'Batch operations',
      subTabs: [],
      type: 'BatchOperations'
    });
  }
  return tabs;
};
